// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Invoice Booklets'" tab="true"></sub-header>
  <div class="info">
    <div class="info__column">
      <div class="info__field">
        <span class="info__field-label">Branch name:</span>
        <span class="info__field-value">{{\$ctrl.branch.name}}</span>
      </div>
      <div class="info__field">
        <span class="info__field-label">Branch code:</span>
        <span class="info__field-value">{{\$ctrl.branch.code}}</span>
      </div>
    </div>
    <div class="info__column">
      <button class="btn btn-primary"
              type="button"
              ng-click="\$ctrl.create()">
        Add new
      </button>
    </div>
  </div>

  <table ng-table="\$ctrl.tableConfig" class="table table--last-column-to-right">
    <thead>
      <tr>
        <th>No.</th>
        <th>Start series</th>
        <th>End series</th>
        <th>User</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="item in \$data" ng-if="\$data">
        <td>{{ \$ctrl.getRowNo(\$index) }}</td>
        <td>{{ item.startSeries }}</td>
        <td>{{ item.endSeries }}</td>
        <td>{{ item.userName }}</td>
        <td class="table__actions">
          <button
            class="btn btn-warning open-link"
            command-access="AssignOfficialReceiptBooklet"
            ng-click="\$ctrl.assign(item.id)">
            Assign
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/official-receipt-booklet/list/official-receipt-booklet-list.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;